<template>
  <div class="main">
    <!-- 标题切换 -->
    <div class="tab_layout">
      <ul class="tab-title">
        <!-- <li class="tab-item" :class="{active:tabSelect==0}" @click="onSelectTab(0)" v-html="$t('行情')"></li> -->
        <li
          class="tab-item"
          :class="{ active: tabSelect === 1 }"
          @click="onSelectTab(1)"
          v-html="$t('MetaEx交易所')"
        ></li>
        <li
          class="tab-item"
          :class="{ active: tabSelect === 2 }"
          @click="onSelectTab(2)"
          v-html="$t('AI机器人')"
        ></li>
      </ul>
      <button class="back" @click="goHome">
        <!-- <img src="../../assets/img/tab_ico_zichan_s.png" alt=""> -->
        {{ $t("返回首页") }}
      </button>
    </div>
    <!-- <div class="dl_line"></div> -->
    <div class="container" v-show="tabSelect == 0">
      <mt-swipe :auto="3000">
        <mt-swipe-item
          class="swipe_item"
          v-for="(item, index) in banner"
          :key="index"
        >
          <img class="slide_img" :src="item.image" alt />
        </mt-swipe-item>
      </mt-swipe>
      <div class="list_head dl_line_bottom">
        <Sort
          v-for="(item, index) in sorts"
          :key="index"
          :title="$t(item.title)"
          :state="item.state"
          @click.native="changeState(index)"
        ></Sort>
      </div>

      <div class="content">
        <mt-loadmore
          :top-method="loadTop"
          :bottom-all-loaded="allLoaded"
          :autoFill="autoFill"
          ref="loadmore"
        >
          <div
            v-for="(item, index) in list"
            :key="index"
            class="list_item dl_line_bottom"
          >
            <!--            <div class="content_item w5">-->
            <!--              <img class="iconF" :src="item.coin_img_url" alt="">-->
            <!--            </div>-->
            <div class="content_item">
              <div class="item1">
                <!--                <img src="../../assets/img/wealth/ico_btc.png" alt="" style="width: 10px">-->
                <span class="coin">{{ item.coin }}</span>
                <span class="dl_font2_color currency"
                  >/{{ item.currency }}</span
                >
              </div>
              <span class="dl_font2_color item1">{{ item.volume }}</span>
              <!--              <span class="dl_font2_color">{{ item.volume }}</span>-->
            </div>
            <div class="content_item w22">
              <span class="dl_font2_color" style="display: block">&nbsp;</span>
            </div>
            <div class="content_item w22">
              <span class="item1 coin">{{ item.price }}</span>
              <span class="dl_font2_color item2"
                >{{ item.currency_symbol }}{{ item.price_usd }}</span
              >
            </div>
            <div class="content_item w25">
              <mt-button
                size="small"
                type="danger"
                :class="computeBtn(item.change)"
                >{{
                  item.change > 0
                    ? "+" + item.change + "%"
                    : "" + item.change + "%"
                }}</mt-button
              >
            </div>
          </div>
        </mt-loadmore>
      </div>
    </div>

    <!-- 交易所 -->
    <div class="jiaoyishuo" v-show="tabSelect == 1">
      <iframe
        id="refMetaearth"
        ref="refMetaearth"
        :src="platforms.metaearth.iframeUrl"
        frameborder="0"
      ></iframe>

      <!-- 底部广告 -->
      <a
        v-show="downloadBar.metaearthex"
        class="download-float"
        href="https://www.metaearthex.com/static/download.html"
      >
        <!-- 叉号图标 -->
        <svg
          class="close"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          @click.stop.prevent="
            () => {
              downloadBar.metaearthex = false;
              popjys = true;
            }
          "
        >
          <path
            d="M829.653687 196.040908C745.000682 111.387903 632.446209 64.766073 512.728594 64.766073c-119.719662 0-232.272088 46.62183-316.926116 131.274836C111.149473 280.694937 64.527642 393.247362 64.527642 512.967024c0 119.717615 46.62183 232.272088 131.274836 316.925093 84.654029 84.655052 197.207477 131.274836 316.926116 131.274836 119.717615 0 232.272088-46.620807 316.925093-131.274836 84.655052-84.653005 131.275859-197.207477 131.275859-316.925093C960.928522 393.247362 914.308739 280.694937 829.653687 196.040908zM512.728594 921.148517c-225.073128 0-408.18354-183.109388-408.18354-408.182516 0-225.072105 183.110411-408.182516 408.18354-408.182516s408.182516 183.110411 408.182516 408.182516C920.91111 738.039129 737.801722 921.148517 512.728594 921.148517z"
            fill="#8a8a8a"
          ></path>
          <path
            d="M541.025057 515.993964l225.347374-225.347374c7.813966-7.813966 7.813966-20.48352 0-28.297486-7.816013-7.813966-20.481474-7.813966-28.297486 0L512.727571 487.696478 287.380196 262.349103c-7.813966-7.813966-20.48352-7.813966-28.297486 0-7.812943 7.813966-7.812943 20.48352 0 28.297486l225.347374 225.347374L257.860882 742.563166c-7.812943 7.813966-7.812943 20.48352 0 28.297486 3.906983 3.90596 9.028631 5.860475 14.149255 5.860475 5.120624 0 10.242272-1.954515 14.149255-5.860475l226.569202-226.569202 226.569202 226.569202c3.908006 3.90596 9.027607 5.860475 14.149255 5.860475 5.121648 0 10.241248-1.954515 14.149255-5.860475 7.813966-7.813966 7.813966-20.48352 0-28.297486L541.025057 515.993964z"
            fill="#8a8a8a"
          ></path>
        </svg>
        <div class="icon">
          <img class="pic" src="@/assets/img/logo-metaearth.png" alt="" />
        </div>
        <div class="con">
          <div class="name">MetaEarthEx</div>
          <div class="sub">Trade anytime, anywhere easy and efficient</div>
        </div>
        <svg
          class="down"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
        >
          <path
            d="M624 706.3h-74.1V464c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v242.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.7c3.2 4.1 9.4 4.1 12.6 0l112-141.7c4.1-5.2 0.4-12.9-6.3-12.9z"
          ></path>
          <path
            d="M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6 0.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4 14.9-19.2 32.6-35.9 52.4-49.9 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7-23.4 23.4-54.5 36.3-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z"
          ></path>
        </svg>
      </a>

      <!-- 是否下载交易所弹框 有不再显示选项 -->
      <mt-popup v-model="popjys" position="bottom" class="pop-close-down">
        <div class="download-float fixed">
          <div class="icon">
            <img class="pic" src="@/assets/img/logo-metaearth.png" alt="" />
          </div>
          <div class="con">
            <div class="name">MetaEarthEx</div>
            <div class="sub">Trade anytime, anywhere easy and efficient</div>
          </div>
        </div>
        <div class="radio-group">
          <mt-button
            type="primary"
            class="item"
            @click="closePop('metaearthex', 0)"
            >今天不再弹出</mt-button
          >
          <mt-button
            type="primary"
            class="item"
            @click="closePop('metaearthex', 1)"
            >已下载APP，不再弹出</mt-button
          >
        </div>
      </mt-popup>
    </div>

    <!-- 量化机器人 -->
    <div class="lianghua" v-show="tabSelect == 2">
      <iframe
        ref="refAleph"
        :src="platforms.aleph.iframeUrl"
        frameborder="0"
      ></iframe>
      <a
        v-show="downloadBar.aleph"
        class="download-float"
        href="https://app2.alephrobot.com/download/download.html"
      >
        <svg
          class="close"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          @click.stop.prevent="
            () => {
              downloadBar.aleph = false;
              poplh = true;
            }
          "
        >
          <path
            d="M829.653687 196.040908C745.000682 111.387903 632.446209 64.766073 512.728594 64.766073c-119.719662 0-232.272088 46.62183-316.926116 131.274836C111.149473 280.694937 64.527642 393.247362 64.527642 512.967024c0 119.717615 46.62183 232.272088 131.274836 316.925093 84.654029 84.655052 197.207477 131.274836 316.926116 131.274836 119.717615 0 232.272088-46.620807 316.925093-131.274836 84.655052-84.653005 131.275859-197.207477 131.275859-316.925093C960.928522 393.247362 914.308739 280.694937 829.653687 196.040908zM512.728594 921.148517c-225.073128 0-408.18354-183.109388-408.18354-408.182516 0-225.072105 183.110411-408.182516 408.18354-408.182516s408.182516 183.110411 408.182516 408.182516C920.91111 738.039129 737.801722 921.148517 512.728594 921.148517z"
            fill="#8a8a8a"
          ></path>
          <path
            d="M541.025057 515.993964l225.347374-225.347374c7.813966-7.813966 7.813966-20.48352 0-28.297486-7.816013-7.813966-20.481474-7.813966-28.297486 0L512.727571 487.696478 287.380196 262.349103c-7.813966-7.813966-20.48352-7.813966-28.297486 0-7.812943 7.813966-7.812943 20.48352 0 28.297486l225.347374 225.347374L257.860882 742.563166c-7.812943 7.813966-7.812943 20.48352 0 28.297486 3.906983 3.90596 9.028631 5.860475 14.149255 5.860475 5.120624 0 10.242272-1.954515 14.149255-5.860475l226.569202-226.569202 226.569202 226.569202c3.908006 3.90596 9.027607 5.860475 14.149255 5.860475 5.121648 0 10.241248-1.954515 14.149255-5.860475 7.813966-7.813966 7.813966-20.48352 0-28.297486L541.025057 515.993964z"
            fill="#8a8a8a"
          ></path>
        </svg>
        <div class="icon">
          <img class="pic" src="@/assets/img/logo-aleph.png" alt="" />
        </div>
        <div class="con">
          <div class="name">Aleph</div>
          <div class="sub">Crypto trading tools</div>
        </div>
        <svg
          class="down"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
        >
          <path
            d="M624 706.3h-74.1V464c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v242.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.7c3.2 4.1 9.4 4.1 12.6 0l112-141.7c4.1-5.2 0.4-12.9-6.3-12.9z"
          ></path>
          <path
            d="M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6 0.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4 14.9-19.2 32.6-35.9 52.4-49.9 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7-23.4 23.4-54.5 36.3-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z"
          ></path>
        </svg>
      </a>
      <mt-popup v-model="poplh" position="bottom" class="pop-close-down">
        <div class="download-float fixed">
          <div class="icon">
            <img class="pic" src="@/assets/img/logo-aleph.png" alt="" />
          </div>
          <div class="con">
            <div class="name">Aleph</div>
            <div class="sub">Crypto trading tools</div>
          </div>
        </div>
        <div class="radio-group">
          <mt-button type="primary" class="item" @click="closePop('aleph', 0)"
            >今天不再弹出</mt-button
          >
          <mt-button type="primary" class="item" @click="closePop('aleph', 1)"
            >已下载APP，不再弹出</mt-button
          >
        </div>
      </mt-popup>
    </div>
  </div>
</template>

<script>
import { setToken } from "@/utils/auth";
import Sort from "@/components/Sort";
import { Toast } from "mint-ui";
import { httpGetHangqingList, httpTickerBanner } from "@/api/hangqing";
import {
  httpCheckAuthBind, //检查是否授权过该platform应用
  httpGetAuthCode, //授权登录获取code
  httpCheckBindEx,
  httpCheckBindQuant, // 检测是否绑定(量化)
} from "@/api/auth";
import { mapState } from "vuex";
export default {
  name: "Index",
  components: { Toast, Sort },
  data() {
    return {
      tabSelect: 1,
      allLoaded: false,
      autoFill: false,
      sorts: [
        {
          title: "资产名",
          state: "1",
          name: "coin",
        },
        {
          title: "交易量",
          state: "0",
          name: "volume",
        },
        {
          title: "价格",
          state: "0",
          name: "price",
        },
        {
          title: "涨跌幅(24H)",
          state: "0",
          name: "change",
        },
      ],
      list: [],
      order: "",
      order_type: "",
      displayType: this.$store.state.hangqing,
      banner: [],
      popupEx: false,
      platforms: {
        metaearth: {
          name: "MetaEarthEX",
        },
        aleph: {
          name: "Aleph",
        },
      },
      popupBind: false,
      bindRadios: [],
      bindValue: "",
      bindResult: {
        is_bind: 0,
        same_users: [],
      },
      downloadBar: {
        metaearthex: false,
        aleph: false,
      },
      popjys: false,
      poplh: false,
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
  },
  methods: {
    loadTop() {
      this.getList();
    },
    loadBottom() {},
    computeBtn: function (change) {
      if (this.displayType == "0") {
        return change > 0 ? "btn dl_green" : "btn";
      } else {
        return change > 0 ? "btn" : "btn dl_green";
      }
    },
    changeState: function (index) {
      let t = this.sorts[index];
      if (t.state == "0") {
        this.sorts.forEach((item, i) => {
          item.state = "0";
          this.$set(this.sorts, i, item);
        });
        t.state = "1";
        this.$set(this.sorts, index, t);
      } else if (t.state == "1") {
        t.state = "2";
        this.$set(this.sorts, index, t);
      } else if (t.state == "2") {
        t.state = "1";
        this.$set(this.sorts, index, t);
      }
      (this.order = t.name),
        (this.order_type = t.state == "1" ? "asc" : "desc"),
        this.getList();
    },
    getList: function () {
      var p = {
        currency: this.$store.state.currency,
        order: this.order,
        order_type: this.order_type,
      };

      // 获取我的行情
      httpGetHangqingList(p)
        .then((res) => {
          this.list = res.data.list;
          this.$refs.loadmore.onTopLoaded();
          this.$refs.loadmore.onBottomLoaded();
        })
        .catch(() => {
          this.$refs.loadmore.onTopLoaded();
          this.$refs.loadmore.onBottomLoaded();
        });
    },
    goHome() {
      this.popupBind = false;
      this.$router.replace("/index/home");
    },
    // 交易所（1）和al机器人(2)切换
    onSelectTab(value) {
      this.popupBind = false;
      this.tabSelect = value;
    },
    async checkAuthBind(platform) {
      // const platform = Object.keys(this.platforms)[this.tabSelect - 1];
      const {
        data: { code },
      } = await httpGetAuthCode({ platform });
      if (platform === "metaearth") {
        this.platforms[
          platform
        ].iframeUrl = `https://www.metaearthex.com/wap/#/home?platform=hmc&code=${code}`;
      } else {
        this.platforms[
          platform
        ].iframeUrl = `https://app2.alephrobot.com/app/#/home?platform=hmc&code=${code}`;
      }
      this.$forceUpdate();
    },
    onSelectAccount(index) {
      const bindResult = this.bindResult;
      for (const key in bindResult.same_users) {
        bindResult.same_users[key].checked = false;
      }
      bindResult.same_users[index].checked = true;
      this.bindResult = { ...bindResult };
      this.bindValue = this.bindRadios[index].value;
    },
    closePop(app, type) {
      if (app === "aleph") {
        this.poplh = false;
        if (type === 0) {
          localStorage.setItem(
            "hide_download_aleph",
            new Date(new Date().toLocaleDateString()).getTime() + 86400000
          );
        } else {
          localStorage.setItem(
            "hide_download_aleph",
            new Date("2222/12/30").getTime()
          );
        }
      } else {
        this.popjys = false;
        if (type === 0) {
          localStorage.setItem(
            "hide_download_metaearthex",
            new Date(new Date().toLocaleDateString()).getTime() + 86400000
          );
        } else {
          localStorage.setItem(
            "hide_download_metaearthex",
            new Date("2222/12/30").getTime()
          );
        }
      }
    },
  },
  mounted: function () {
    this.getList();
    this.checkAuthBind("metaearth");
    this.checkAuthBind("aleph");
  },
  activated: function () {
    const hide_download_metaearthex = localStorage.getItem(
      "hide_download_metaearthex"
    );
    const hide_download_aleph = localStorage.getItem("hide_download_aleph");
    this.downloadBar.metaearthex =
      !hide_download_metaearthex || hide_download_metaearthex <= +Date.now();
    this.downloadBar.aleph =
      !hide_download_aleph || hide_download_aleph <= +Date.now();
    this.displayType = this.$store.state.hangqing;
  },
};
</script>

<style scoped lang="less">
.download-float {
  position: absolute;
  bottom: 10px;
  left: 10px;
  right: 10px;
  background-color: #fff;
  padding: 15px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  &.fixed {
    position: static;
    padding: 0 0 15px;
    border-bottom: 1px solid #f6f6f6;
  }
  .close {
    position: absolute;
    top: 2px;
    right: 2px;
  }
  .icon {
    width: 48px;
    height: 48px;
    margin-right: 10px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    box-sizing: border-box;
    .pic {
      max-width: 100%;
    }
  }
  .con {
    flex: 1;
    min-width: 0;
  }
  .tit {
    font-size: 16px;
    font-weight: bold;
  }
  .sub {
    font-size: 12px;
    margin-top: 5px;
    color: #999;
  }
}
.main {
  height: 100%;
  overflow: hidden;
  /* padding-top: 40px; */
}

.container {
  padding: 40px 10px 10px 10px;
  margin-top: 15px;
}

.top_icon {
  width: 15px;
}

.list_item {
  height: 60px;
  padding-top: 10px;
  box-sizing: border-box;
  border-bottom: solid 1px #f4f4f4;
}

.content_item {
  float: left;
  // display: inline-block;
  width: 25%;
  text-align: center;
  font-size: 12px;
  line-height: 40px;
}

.w5 {
  width: 10%;
  text-align: left;
}

.w15 {
  width: 15%;
}

.w25 {
  width: 25%;
}

.w35 {
  width: 35%;
}

.content_item .item1 {
  line-height: 20px;
  display: block;
  text-align: left;
}

.content_item .item2 {
  line-height: 20px;
  display: block;
  font-weight: 400;
  position: relative;
  left: -3px;
}

/*.content_item,*/
.head_item:first-child {
  text-align: left;
}

.head_item:last-child,
.content_item:last-child {
  text-align: right;
}

.content_item .dl_font2_color {
  text-align: left;
}

.coin {
  font-size: 14px;
  font-weight: 700;
}

.currency {
  font-size: 10px;
  font-weight: 400;
}

.btn {
  width: 75px;
}

.mint-loadmore {
  margin-top: 15px;
}

.mint-button {
  border-radius: 0px;
}

.mint-button--danger {
  background-color: #f6673d;
}

.head_item {
  color: #1d3d57;
}

.content {
  height: calc(100vh - 40px - 110px - 100px);
  overflow: auto;
  margin-top: 50px;
  background: #fdfdfd;
  padding: 0 15px;
}

.mint-swipe {
  height: 100px;
  border-radius: 5px;
  margin: 5px 0 10px;
}

.slide_img {
  height: 100px;
  width: 100%;
  display: block;
}

.list_head {
  position: fixed;
  width: calc(100% - 20px);
  background: #fff;
  padding: 5px 0;
  z-index: 99;
  box-shadow: 0 5px 1px 0 rgba(0, 0, 0, 0.03);
}

.iconF {
  width: 20px;
  padding-top: 10px;
}

.tab_layout {
  height: 50px;
  position: fixed;
  top: 0;
  z-index: 99;
  width: 100%;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  .back {
    position: absolute;
    right: 15px;
    font-size: 12px;
    padding: 6px 0;
    background-color: transparent;
    color: #1980d6;
  }

  ul {
    border: 1px solid #1980d6;
    border-radius: 5px;
    width: 60%;
    margin: 0 auto;
    height: 30px;
    overflow: hidden;
    padding: 1px;
    display: flex;

    li {
      flex: 1;
      text-align: center;
      line-height: 30px;
      font-size: 14px;
      border-radius: 5px;
    }

    li.active {
      color: #fff;
      background-color: #1980d6;
    }
  }
}

//嵌套的网页
.jiaoyishuo,
.lianghua {
  height: 100%;
  padding-bottom: 0px;
  // margin-top: 50px;
}

iframe {
  width: 100%;
  height: 91%;
  margin-top: 60px;
}

.mint-popup {
  z-index: 19999 !important;
}

/deep/ .v-modal {
  z-index: 19998 !important;
}
// .mint-popup {
//   // border-radius: 8px;
// }
.auth-pop {
  width: 80vw;
  &.s2 {
    width: 100vw;
    padding-bottom: 20px;
    .btns {
      margin-top: 20px;
      // box-sizing: border-box;
      // position: absolute;bottom: 0;left: 0;width: 100%;
    }
  }

  .hd {
    display: flex;
    align-items: center;
    padding: 15px;
    font-size: 14px;

    img {
      width: 24px;
      height: 24px;
      margin-right: 12px;
    }
  }

  .con {
    padding: 0 15px;

    .tit {
      font-size: 15px;
      margin-bottom: 5px;
    }

    .sub {
      font-size: 12px;
      color: #666;
    }
  }

  .user {
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    padding: 15px;
    margin: 15px 0;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #666;
    img {
      width: 32px;
      height: 32px;
      margin-right: 8px;
      border-radius: 5px;
    }
  }

  .btns {
    padding: 20px;
    display: flex;
    justify-content: center;

    .btn {
      margin: 0 10px;
      border-radius: 8px;
      width: 86px;
    }
  }
}
.bind-radio {
  /deep/.mint-radiolist-title {
    padding: 0 10px;
    font-size: 15px;
    color: #000;
  }
  /deep/.mint-radiolist-label {
    display: flex;
    line-height: 20px;
  }
}
.auth-caption {
  padding: 15px;
  font-size: 16px;
  color: #333;
  margin-bottom: 10px;
}
.auth-table {
  width: 100%;
  text-align: left;
  th {
    background-color: #f8f8f8;
    font-size: 14px;
    font-weight: normal;
    padding: 10px 5px;
    box-sizing: border-box;
  }
  td {
    padding: 5px;
    font-size: 14px;
    height: 50px;
    box-sizing: border-box;
    word-break: break-all;
    border-bottom: 1px solid #eee;
  }
}

.pop-close-down {
  width: 100vw;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 16px 16px 0 0;
  overflow: hidden;
  .title {
    font-weight: bold;
    margin-bottom: 15px;
  }
  .radio-group {
    padding-top: 20px;
    .item {
      font-size: 14px;
      display: block;
      width: 100%;
      margin: 20px 0;
      border-radius: 5px;
    }
  }
}
</style>
